import styled from 'styled-components';
import { Icon, Flex } from 'ui';
import { LoadingOutlined } from '@ant-design/icons';

const StepText = styled.span`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 14px;
`;

const IconContainer = styled(Flex)`
  width: 20px;
  height: 20px;
  margin-right: 5px;
  margin-left: 5px;
`;

export const ErrorIconContainer = styled(IconContainer)`
  border: 1px solid ${p => p.theme.colors.publishSteps.error} !important;
  border-radius: 50%;
  background-color: ${p => p.theme.colors.publishSteps.error} !important;
`;

export const ErrorText = styled(StepText)`
  color: ${p => p.theme.colors.publishSteps.error} !important;
  margin-right: 5px;
`;

export const FinishIconContainer = styled(IconContainer)`
  border: 1px solid ${p => p.theme.colors.publishSteps.finish} !important;
  border-radius: 50%;
`;

export const FinishIcon = styled(Icon)`
  color: ${p => p.theme.colors.publishSteps.finish} !important;
`;

export const FinishText = styled(StepText)`
  color: ${p => p.theme.colors.publishSteps.finish} !important;
`;

export const ProcessIconContainer = styled(IconContainer)``;

export const ProcessIcon = styled(LoadingOutlined)`
  font-size: 15px;
  color: ${p => p.theme.colors.publishSteps.process} !important;
`;

export const ProcessText = styled(StepText)`
  color: ${p => p.theme.colors.publishSteps.process} !important;
`;

export const StyledDivShortSteps = styled.div`
  background-color: #F7F9FB;
  height: auto;
  ${p => p.isSidePanel && `
    padding: 10px 0;
    margin: -13px !important;
    margin-bottom: 0px !important;
  `};
  ${p => !p.isSidePanel && `
    width: 100% !important;
    height: 100%;
  `};
  cursor: default !important;
  ${p => p.needsBorder && `
    border: 2px solid ${p.theme.colors.publishSteps.error};
  `}
`;

export const StyledFlex = styled(Flex)`
  width: 100% !important;
  height: 100%;
  background-color: #F7F9FB;
  margin-right: 15px;
`;
